export class FligthInspectionConfigAbstract{
    fieldSeparator: string;
	
	thousandSeparator: string;
	
	useThousandSeparator: boolean;

	startingLineIndex: number;
	headerLine: number;

	decimalSeparator: string;
    decimate: boolean;
	decimateSample: number;
}